var name = "";
var email = "";
var gender = "";
var product = "";
var choosing = { 'options1': String };
//1-2级别向上返回按钮触发事件方法
function backButton() {
    let flexQuizesDataIds = [];
    $('.quize_items .quize').each(function () {
        if ($(this).css('display') === 'flex') {
            let dataQuizKitId = $(this).data('quiz-kit-id');
            flexQuizesDataIds.push(dataQuizKitId);
        }
    });

    if (flexQuizesDataIds[0] > 0 && flexQuizesDataIds[0] <= 3) {
        $('.quize_items .quize[data-quiz-kit-id="' + flexQuizesDataIds[0] + '"]').css('display', 'none');
        $('.quize_items .quize[data-quiz-kit-id="' + (flexQuizesDataIds[0] - 1) + '"]').css('display', 'flex');
    } else if (flexQuizesDataIds[0] >= 3) {
        $('.quize_items .quize[data-quiz-kit-id="' + flexQuizesDataIds[0] + '"]').css('display', 'none');
        $('.quize_items .quize[data-quiz-kit-id="3"]').css('display', 'flex');
    }
}
//end 1-2级别向上返回按钮触发事件方法

//发送邮件
function sendEmail() {
    emailjs.init("dboTb2n7tvToN-CZm");
    var templateParams = {
        from_name: name,
        from_email: email,
        from_gender: gender,
        from_product: product,
        message: "choosing Data:" + Object.values(choosing)
    }
    emailjs.send('service_lmqzs3h', 'template_hyeuqn5', templateParams)
        .then(function (response) {
            console.log('SUCCESS!', response.status, response.text);
        }, function (error) {
            console.log('FAILED...', error);
        });
}
//end发送邮件

//最终产品渲染星级
function JudgmentLevel(level) {
    var JudgmentLevel = '';
    switch (level) {
        case 5:
            svgContent = `
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            `;
            break;
        case 4:
            svgContent = `
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUtJREFUSEu1ldFxwkAMRJdKIJ2ETqASkkqSVAKdQCcwj7nNCKM7yx/Wz9mMrJW0u8dGK8dm5fpaCnCWdJN0rDa2BOAg6acV3ku6VECWAND9ZytKcUBmowpAYQBilKaoArj774ZwaiuanaICsJN0bYU/2sm7yR5yEQEoBJFbSTwTnH7+DeqBbHIBIaYnkz5/iwCRxCl5JLMOFwKUfINn+c9pI8CXJHZLMLa7cNFMMXFSvrXK8AkTvxktggDAeyXi9C/qykiOhqqAuHhKek9FVdcOi2criuuwUqJ6pusyQNd0Ix/443/CEjLcRHeVI4B7MBf7RTEU5AQUpfkK6d5NFQ7Iieqysf6aFO1qu/xl0DkAOotujndRdDA5KQ89AO/W3UwlmDk5FUMPgLHt0h6Bvrvsfpp4W9NoAgg0mSM3m/z0r7RyXVeuim7O6gAPomFVGUVBTa4AAAAASUVORK5CYII="/>
            `;
            break;
        case 4.5:
            svgContent = `
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT1JREFUSEu1letRAzEMhDeVJHRCOiGVAJUAlYROkk6S+W4sRlEs2cfM6c89rdV6V/JOG8du4/xaC3CWdJV0mi1sDcCbpK+W+CjpdwZkDQDVv7akJAdkGLMAJAbAxxSLWQBf/aek97ZFQxYzAAdJF1f6S3s2sUstPACJEHIviXuCq90bBmsQm38BIeIVlss7D+C3oRKPNZFV/J/kMH0A+Gh7O3JGZG1M0cVcRp98RwCeZ0B6unn2D+7q/ewbqscmrrHkXdEzF1UgPd1SR1U2NadEFj2AtOkqgMxVfo0VgS3R7ykqgFtiJ78dNkLS2fQfDayxfpoV6fI/31f76b9lIrMVBJ73HUzjdXXIGESBo0tIiEZ+jNBYTwdRBgBtW5wJaLPLs1nGg4+KAQJS0ejkAgjG3aN0ZlyPZlP5fXOAO3vFRxkqUm6LAAAAAElFTkSuQmCC"/>
            `;
            break;
        case 3.5:
            svgContent =
                `
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQ9JREFUSEu1ldsRAjEIRe9WonainWglaiXaiXainegcZ+NgJFnwwc8+w4FcIIP+bMOf/SsLOEm6StpEA8sA1pIOo+OVpHMEkgEQ/XJ0inMgkxYF4BiAtVAWUYCNvkBCWUQAc0kXZy+K2F0tLABHCDmTxD3Gtdx7+w0Eq6/78s4CvG2YFLHxA8AF3yxgJ2n7qcdqHX1yrAE8/wLyUl2eyLahMgm5oreqKAtpVlSvTBkLgCLWbLoeIFNVlCX6vVkPcIuEPv7T7OpfavCo+9qyALYC8/rF1aEFqAWuq4TxgUZ2jNBYbwdRC8BwK4tbApbZVbJ5jge7Tb0MOAOIaOrkAkTG7lEaGdeJYoqL/JVTu/gOKd82GTFQwxMAAAAASUVORK5CYII="/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT1JREFUSEu1letRAzEMhDeVJHRCOiGVAJUAlYROkk6S+W4sRlEs2cfM6c89rdV6V/JOG8du4/xaC3CWdJV0mi1sDcCbpK+W+CjpdwZkDQDVv7akJAdkGLMAJAbAxxSLWQBf/aek97ZFQxYzAAdJF1f6S3s2sUstPACJEHIviXuCq90bBmsQm38BIeIVlss7D+C3oRKPNZFV/J/kMH0A+Gh7O3JGZG1M0cVcRp98RwCeZ0B6unn2D+7q/ewbqscmrrHkXdEzF1UgPd1SR1U2NadEFj2AtOkqgMxVfo0VgS3R7ykqgFtiJ78dNkLS2fQfDayxfpoV6fI/31f76b9lIrMVBJ73HUzjdXXIGESBo0tIiEZ+jNBYTwdRBgBtW5wJaLPLs1nGg4+KAQJS0ejkAgjG3aN0ZlyPZlP5fXOAO3vFRxkqUm6LAAAAAElFTkSuQmCC"/>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUtJREFUSEu1ldFxwkAMRJdKIJ2ETqASkkqSVAKdQCcwj7nNCKM7yx/Wz9mMrJW0u8dGK8dm5fpaCnCWdJN0rDa2BOAg6acV3ku6VECWAND9ZytKcUBmowpAYQBilKaoArj774ZwaiuanaICsJN0bYU/2sm7yR5yEQEoBJFbSTwTnH7+DeqBbHIBIaYnkz5/iwCRxCl5JLMOFwKUfINn+c9pI8CXJHZLMLa7cNFMMXFSvrXK8AkTvxktggDAeyXi9C/qykiOhqqAuHhKek9FVdcOi2criuuwUqJ6pusyQNd0Ix/443/CEjLcRHeVI4B7MBf7RTEU5AQUpfkK6d5NFQ7Iieqysf6aFO1qu/xl0DkAOotujndRdDA5KQ89AO/W3UwlmDk5FUMPgLHt0h6Bvrvsfpp4W9NoAgg0mSM3m/z0r7RyXVeuim7O6gAPomFVGUVBTa4AAAAASUVORK5CYII="/>`;
            break;
        default:
            svgContent = '';
    }
    return svgContent;
}
//end最终产品渲染星级

//最终产品icon渲染
function iconRender(icon) {
    var iconContent = '';
    image = 'https://cdn.shopify.com/s/files/1/0523/5048/4641/files/'
    console.log(icon)
    switch (icon) {
        case '#39':
            return iconContent = `<img src="${image}39.svg?v=1741242249" alt="${icon}">`;
            break;
        case '#40':
            return iconContent = `<img src="${image}40.svg?v=1741242249" alt="${icon}">`;
            break;
        case '#45':
            return iconContent = `<img src="${image}45.svg?v=1741242248" alt="${icon}">`;
            break;
        case 'Buoyancy':
            return iconContent = `<img src="${image}Buoyancy.svg?v=1741242249" alt="${icon}">`;
            break;
        case 'Even Buoyancy':
            return iconContent = `<img src="${image}Even_Buoyancy.svg?v=1741319173" alt="${icon}">`;
            break;
        case 'Fish Scale':
            return iconContent = `<img src="${image}Fish_Scale_aa20aaf8-c74d-4423-93e2-8a4dbb71d096.svg" alt="${icon}">`;
            break;
        case 'Leg Buoyancy':
            return iconContent = `<img src="${image}Leg_Buoyancy.svg?v=1741242249" alt="${icon}">`;
            break;
        case 'NANO SCS':
            return iconContent = `<img src="${image}NANO_SCS_e910e8c7-4249-4df4-9654-4c7451be5587.svg" alt="${icon}">`;
            break;
        case 'SCS':
            return iconContent = `<img src="${image}SCS_b1c9ee2c-cb8d-4372-b9f6-b9bcee9b7c69.svg" alt="${icon}">`;
            break;
        case 'Torso Buoyancy':
            return iconContent = `<img src="${image}Torso_Buoyancy.svg?v=1741242249" alt="${icon}">`;
            break;
        case 'Sleeveless':
            return iconContent = `<img src="${image}Sleeveless.svg?v=1741242248" alt="${icon}">`;
            break;
    }
}
//最终产品icon渲染

//input失去焦点判断是否存在内容激活下一步按钮
function IputBlur(panduan) {
    if (panduan) {
        $('.quize-flex1 button').prop('disabled', true);
    } else {
        $('.quize-flex1 button').prop('disabled', false);
    }
}
$('.quize-flex1 input[type="text"]').on('blur keyup', function () {
    if ($('.quize-flex1 input[type="text"]').val() == '') { IputBlur(true) } else { IputBlur(false) };
})
//end input失去焦点判断是否存在内容激活下一步按钮

//点击下一步按钮，并对数据进行存储，然后跳转第二部
$('.quize-flex1 button').on('click', function () {
    name = $('.quize-flex1 input[type="text"]').val()
    email = $('.quize-flex1 input[type="email"]').val()
    gender = $('input[name="gender"]:checked').val()
    console.log(name, email, gender)
    if ($('input[name="gender"]:checked').length == 0) {
        alert('Please choose your body shape.')
    } else {
        gender = $('input[name="gender"]:checked').val()
        $('.quize-flex1').hide();
        $('.quize-flex2').css('display', 'flex');
    }

})
//end点击下一步按钮，并对数据进行存储，然后跳转第二部

  // 第二个模块的，并对数据进行储存和打印，显示选择得品类目录进行展示
  $('.quize-flex2 #Next_btn').off('click').on('click', function () {
      console.log($('input[name="product"]:checked').val())
      console.log($('input[name="product"]:checked').length)
      if ($('input[name="product"]:checked').length == 0) {
          alert('Please choose the sport.')
      } else {
          product = $('input[name="product"]:checked').val()
          console.log(product)
          $('.quize-flex2').hide();
          $(`.quize[data-produt_template='${product}']`).css('display', 'flex');
          //获取数据
          //end获取数据
      }
  })
  //end第二个模块的，并对数据进行储存和打印，显示选择得品类目录进行展示

//end第二个模块的，并对数据进行储存和打印，显示选择得品类目录进行展示
$('.quize-flex2 #back_btn').on('click', function () {
    backButton()
})
//end 返回上一层与重新测试

// 定义一个公共函数来处理点击事件逻辑
function handleNextButtonClick(event, product) {
    console.log('测试')
    let isLast = $(event.currentTarget).hasClass('Submit_Parametersbtn'); // 获取是否点击的是最后的结果提交按钮
    var currentStep = $(event.currentTarget).parents('.SplitOptions'); // 获取点击按钮的父级元素
    let currentStepId = currentStep.data(`${product.toLowerCase()}_id`); // 获取当前步骤ID
    let level_choose = currentStep.data('choose'); // 获取元素是否只存在一项
    let level_options = `.SplitOptions[data-${product.toLowerCase()}_id="${currentStepId}"]`;
    let value = $(`${level_options} input[type="radio"]:checked`);
    let value_name = $(`${level_options} input[type="radio"]`).attr('name');
    let data_choosing = `options${currentStepId}`;
    publlicdata(product, product.toLowerCase(), isLast, currentStep, currentStepId, level_choose, level_options, value, value_name, data_choosing);
}
// end定义一个公共函数来处理公共数据逻辑

// 定义一个公共函数来处理点击事件逻辑
function publlicdata(product, str, isLast, currentStep, currentStepId, level_choose, level_options, value, value_name, data_choosing) {
    if (!isLast) {
        console.log('不是最后一步');
        if (value.val()) {
            let next = true;
            if (value.data('show')) {
                if (value.data('show')) {
                    BranchLineData(data_choosing, value.val());
                    console.log(name, email, gender, product, choosing);
                    xx();
                    next = false;
                } else {
                    next = true;
                }
            }
            currentStep.attr('data-choose_name', value); // 增加data属性,对下级返回上级
            if (level_choose == 2) {
                BranchLineData(data_choosing, value.val());
                currentStep.css('display', 'none');
                let data_options = `.SplitOptions[data-options="${value.val()}"][data-${str}_id="${currentStepId + 1}"]`;
                $(data_options).css('display', 'flex');
            } else {
                if (next) {
                    BranchLineData(data_choosing, value.val());
                    currentStep.css('display', 'none');
                    let data_options = `.SplitOptions[data-options="${value_name}"][data-${str}_id="${currentStepId + 1}"]`;
                    $(data_options).css('display', 'flex');
                }
            }
        } else {
            alert('Please make a choice.');
        }
    } else {
        if (value.val()) {
            BranchLineData(data_choosing, value.val());
            xx();
        } else {
            alert('Please make a choice.');
        }
        console.log('sadasdsdas', isLast);
    }
}
// end定义一个公共函数来处理公共数据逻辑

// 使用命名空间解绑和绑定事件
function bindNextButtonEvents() {
    $(`.quize[data-produt_template="Triathlon"] .Next_btn`).off('click.next').on('click.next', function (event) {
        handleNextButtonClick(event, 'Triathlon');
    });

    $(`.quize[data-produt_template="OpenWaterSwimming"] .Next_btn`).off('click.next').on('click.next', function (event) {
        handleNextButtonClick(event, 'OpenWaterSwimming');
    });

    $(`.quize[data-produt_template="Swimrun"] .Next_btn`).off('click.next').on('click.next', function (event) {
        handleNextButtonClick(event, 'Swimrun');
    });
}
// end使用命名空间解绑和绑定事件

// 初始化事件绑定
    bindNextButtonEvents();
// end初始化事件绑定

//定义一个公共函数来处理数据存储
function BranchLineData(data_choosing, value) {
    if (choosing.hasOwnProperty(data_choosing)) {
        choosing[data_choosing] = value;
    } else {
        choosing[data_choosing] = value;
    }
}
//end定义一个公共函数来处理数据存储

//提交数据与数据渲染
function xx() {
    $(`.quize[data-produt_template='${product}']`).css('display', 'none');
    $('.quize-flex7').css('display', 'flex')
    //对数据开始进行筛选
    const data = gender == 'Men' ? products[0].Men : products[0].Women//筛选性别
    let arr = data.reduce((acc, data) => {//筛选产品
        if (data.product == product) {
            acc.push(data)
        }
        return acc;
    }, [])
    let filteredData = [];
    // 外部循环遍历 choosing 的所有值
    for (let i = 0; i < Object.keys(choosing).length; i++) {
        if (filteredData.length === 0) {
            for (let k = 0; k < arr.length; k++) {
                let data = arr[k];  // 使用 k 作为内层循环索引来访问 arr 数组的每个元素
                // 判断是否有 optionData
                if (data.optionData) {//第一轮筛选
                    switch (Object.values(choosing)[i]) {
                        case 'Price':
                            var priceInterval = true;
                            let sleeveless = Object.values(choosing)[i + 2] == 'Yes' ? true : false
                            if (Object.values(choosing)[i + 1] == 'EntryLevel') {
                                priceInterval = (244.99 <= data.price && data.price <= 369.99);
                            } else if (Object.values(choosing)[i + 1] == 'MidRange') {
                                priceInterval = (439.99 <= data.price && data.price <= 559.99);
                            } else {
                                priceInterval = (649.99 <= data.price && data.price <= 1199.99);
                            }
                            if (priceInterval) {
                                if (sleeveless) {
                                    if (data.name.includes('Sleeveless')) {
                                        filteredData.push(data); // 如果匹配，加入到结果数组
                                    }
                                } else {
                                    if (!data.name.includes('Sleeveless')) {
                                        filteredData.push(data); // 如果匹配，加入到结果数组
                                    }
                                }
                            }
                            break;
                        case 'Performance':
                            if (data.property.includes(Object.values(choosing)[i + 1])) {
                                filteredData.push(data)
                            }
                            break;
                    }
                } else {
                    if (data.ProductOptions === Object.values(choosing)[i]) {
                        filteredData.push(data);  // 如果匹配，加入到结果数组
                    }
                }
            }
        }
    }
    console.log('testData:', filteredData);  // 输出最终过滤后的数据
    // end对数据进行筛选
    //打印数据
    $('.FinalTitle').html(
        `<h1 class="FinalTitle">Use code Quiz20 to get 20% off your purchase...</h1>`
    )
    // end打印数据
    for (i = 0; i < filteredData.length; i++) {
        const product_name = filteredData[i].name
        const option = filteredData[i].optionData
        const flexibility = JudgmentLevel(filteredData[i].flexibility)
        const buoyancy = JudgmentLevel(filteredData[i].buoyancy)
        const speed = JudgmentLevel(filteredData[i].speed)
        const thermal = JudgmentLevel(filteredData[i].thermal)
        const describe = filteredData[i].describe ? filteredData[i].describe : ''
        $(`.Product_Shop_item`).append(
            `<div class="Product_Shop product_Details${filteredData.length}">
            <div class="image_layout">
            <div class="list_svg"></div>
            <div class="product_img"><img src="${filteredData[i].image_url}" alt="${filteredData[i].name}"></div>
            </div>` +
            `<h2 class="product_Title">${filteredData[i].name}</h2>` +
            `<div class="product_svg_list">Flexibility:${flexibility}</div>` +
            `<div class="product_svg_list">Buoyancy:${buoyancy}</div>` +
            `<div class="product_svg_list">Speed:${speed}</div>` +
            `<div class="product_svg_list">Thermal:${thermal}</div>` +
            `<div class="product_Describe">${describe}</div>` +
            `<div class="product_price">EUR ${filteredData[i].price}</div>` +
            `<a href="${filteredData[i].product_url}" class=" btn btn--no-animate register--button" style="width:93%;">SHOP NOW</a>` +
            `</div>`)
        if (filteredData[i].optionData) {
            let axs;
            if (Object.values(choosing)[0] == 'Price') {
                axs = option[Object.values(choosing)[0]]
                console.log(`渲染Price：`, option[Object.values(choosing)[0]].length);
            } else {
                axs = option[[Object.values(choosing)[0]]][Object.values(choosing)[1]]
                console.log(`渲染Performance：`, option[[Object.values(choosing)[0]]][Object.values(choosing)[1]].length);
            }
            let currentProduct = $(`.product_Details${filteredData.length}`).last(); // 选择当前商品的 `.Product_Shop`
            for (k = 0; k < axs.length; k++) {
                currentProduct.find('.list_svg').append(`
            <div class="list_svg_item">
                <div class="list_svg_item_icon">${iconRender(axs[k].icon)}</div>
                <div class="list_svg_item_title">${axs[k].title}</div>
                <div class="list_svg_item_content">${axs[k].content}</div>
            </div>`);
            }
        }
    }
    console.log('最终数据:', name, email, gender, product, choosing)
    sendEmail()
    filteredData = []
    console.log('filteredData', filteredData)
}
// end提交数据与数据渲染

//返回上一层与重新测试
$('.SplitOptions .Back_btn').on('click', function () {
    //获取祖父元素中data-Triathlon_id中得数字
    var id = $(this).parents('.SplitOptions').attr(`data-${product}_id`)
    var template = $(this).parents('.quize').attr('data-produt_template')
    if (id == 1) {
        $(`.quize[data-produt_template="${template}"]`).css('display', 'none')
        $('.quize-flex2').css('display', 'flex')
    } else {
        $(`.SplitOptions[data-${product}_id="${id}"]`).css('display', 'none')
        $(`.SplitOptions[data-${product}_id="${id - 1}"][data-choose_name]`).css('display', 'flex')
        $(`.SplitOptions[data-${product}_id="${id - 1}"]`).removeAttr('data-choose_name');
    }
    //
    const keys = Object.keys(choosing);
    const lastKey = keys[keys.length - 1];
    delete choosing[lastKey];
    console.log(choosing)
    //去除单选按钮的选项
    let a = $(this).parents('.SplitOptions');
    a.find('input[type="radio"]').prop('checked', false);
})
//end返回上一层与重新测试

//重新测试
$('.RetakeQuizBtn').on('click', function () {
    $('.quize-flex7').css('display', 'none');
    $(`.quize[data-produt_template='${product}'] .SplitOptions`).css('display', 'none');
    $(`.quize[data-produt_template='${product}'] .SplitOptions:first-child`).css('display', 'flex');
    $(`.Product_Shop_item`).html('')
    $('.quize-flex1').css('display', 'flex');
})
//end重新测试
//渲染数据的上层
$('.quize-flex7.quize .Back_btn').on('click', function () {
    $('.quize-flex7').css('display', 'none');
    $(`.Product_Shop_item`).html('')
    $(`.quize[data-produt_template='${product}']`).css('display', 'flex');
})
//end渲染数据的上层